//bao migrate skip
import "./../../interfaces/ipage";
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import tabPage from "./../../factories/tab-page";

class InfoSapDialog {
    TabPage: tabPage;
    DialogResult: KnockoutObservable<boolean> = ko.observable(false);
    ReportedBy = ko.observable<string>("");
    SapWorkCenterId: KnockoutObservable<string> = ko.observable("");
    SapCodeGroupId: KnockoutObservable<string> = ko.observable("");
    FunctionalLocation: KnockoutObservable<string> = ko.observable("");
    FunctionalLocationObject = ko.observable<any>();
    AreaSapId: KnockoutObservable<string> = ko.observable("");
    AreaEquipmentSapId: KnockoutObservable<string> = ko.observable("");
    Equipment: KnockoutObservable<string> = ko.observable("");
    EquipmentObject = ko.observable<any>();
    Text1: KnockoutObservable<string> = ko.observable("");
    SelectedPriority = ko.observable<any>();
    CodeGroup: KnockoutObservable<string> = ko.observable("");
    CodeGroupEquipment: KnockoutObservable<string> = ko.observable("");
    Coding: KnockoutObservable<string> = ko.observable("");
    CodeGroupObject = ko.observable<any>();
    SapPriorityNumber: KnockoutObservable<string> = ko.observable("");
    Priority: KnockoutObservable<string> = ko.observable("");
    PriorityObject = ko.observable<any>();
    Priorities = ko.observableArray();
    Plangroups = ko.observableArray();
    Parent = ko.observable();
    AreaMandatory = ko.observable(false);
    EquipmentMandatory = ko.observable(false);
    IsNewNotification = ko.observable(false);
    constructor(tabPage: TabPage) {
        this.TabPage = tabPage;
        this.FunctionalLocationObject.subscribe((newValue) => {
            if (newValue != null) {
                this.ChangeFunctionalLocationObject(newValue.Name1);
            }
        });
        this.EquipmentObject.subscribe((newValue) => {
            if (newValue != null) {
                this.Equipment(newValue.EquipmentText1);
                this.CodeGroupEquipment(newValue.EquipmentText2);
            }
        });
        this.CodeGroupObject.subscribe((newValue) => {
            if (newValue != null) {
                this.Coding(newValue.Name1);
                this.CodeGroup(newValue.Name2);
            }
        });
        this.PriorityObject.subscribe((newValue) => {
            if (newValue != null) {
                this.Priority(newValue.SapPriorityNumber());
            }
        });
    }
    ChangeFunctionalLocationObject(technPlace: string) {
        this.FunctionalLocation(technPlace);
    }
    ItemCompleteCheck() {
        if (this.AreaMandatory() && (this.AreaSapId() === null || this.AreaSapId() === "")
            || this.EquipmentMandatory() && (this.AreaEquipmentSapId() === null || this.AreaEquipmentSapId() === "")
            || this.ReportedBy() === null || this.ReportedBy() === ""
            || this.Text1() === null || this.Text1() === "") {
            return false;
        }
        return true;
    }
    DialogWidth: number = 1000;
    DialogHeight: number = 650;
    Show(infoId, tabPage): JQueryPromise<void> {
        return Bao.post("Information/ShowInfoSapDialog", JSON.stringify({
            infoId: infoId
        }), (result) => {
            this.TabPage.IsLoading(true);
            this.GetPriorities();
            this.GetPlanGroups();
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.ViewModel(this);
            var mappedItem = ko.map.fromJS(result.Model, this);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                if (this.ItemCompleteCheck()) {
                    var item = ko.map.toJS(mappedItem);
                    this.CreateNotification(item);
                    this.DialogResult(true);
                    dialog.Close();
                }
                else {
                    var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                this.DialogResult(false);
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            if (this.IsNewNotification()) {
                dialog.Buttons([okButton, cancelButton]);
            }
            else {
                dialog.Buttons([cancelButton]);
            }
            dialog.Template(result.Message);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
    GetPriorities() {
        return Bao.post('SapPriority/GetPriorities', JSON.stringify({})).then((result) => {
            ko.map.fromJS(result, this.Priorities);
        });
    }
    ;
    GetPlanGroups() {
        return Bao.post('SapPlanGroup/GetPlanGroups', JSON.stringify({})).then((result) => {
            ko.map.fromJS(result, this.Plangroups);
        });
    }
    ;
    SearcherWorkCenter: Bindings.baoSearcher = {
        ObjectId: this.SapWorkCenterId,
        ObjectValue: 'Name1',
        AutoComplete: true,
        Enabled: this.IsNewNotification,
        SearchType: 'SapWorkCenter',
        AutoSearch: true
    };
    SearcherCodeGroup: Bindings.baoSearcher = {
        ObjectId: this.SapCodeGroupId,
        ObjectValue: 'DescriptionLong',
        SelectedItem: this.CodeGroupObject,
        AutoComplete: true,
        SearchType: 'SapCodeGroup',
        Enabled: this.IsNewNotification,
        AutoSearch: true,
        CustomFilter: {
            codeGroup: this.CodeGroupEquipment
        }
    };
    SearcherFunctionalLocation: Bindings.baoSearcher = {
        ObjectId: this.AreaSapId,
        ObjectValue: 'Name1',
        SelectedItem: this.FunctionalLocationObject,
        Enabled: this.IsNewNotification,
        AutoComplete: true,
        SearchType: 'AreaSap',
        AutoSearch: false
    };
    SearcherEquipment: Bindings.baoSearcher = {
        ObjectId: this.AreaEquipmentSapId,
        ObjectValue: 'EquipmentText1',
        SelectedItem: this.EquipmentObject,
        Enabled: this.IsNewNotification,
        AutoComplete: true,
        SearchType: 'AreaEquipmentSap',
        AutoSearch: false,
        CustomFilter: {
            areaSapId: this.AreaSapId
        }
    };
    CreateNotification(item) {
        return Bao.post("Information/CreateNotification", JSON.stringify({
            model: item
        }), (result) => {
            if (result.IsCreated == true) {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
            else if (result.IsCreated == false) {
                //    this.Parent.TabPage.IsLoading(false);
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
}
export default InfoSapDialog;